/**
 * Inbox-tab query hook. Same shape as `use-briefs.ts`: key on the semantic
 * filter set (not the raw URL), 60s stale time. `keepPreviousData` no longer
 * keeps the previous page on screen: `useFilteredQuery` reports that window as
 * "nothing counted yet" (hooks/use-filtered-query.ts), so the tiles and the
 * table blank and <RecountNotice> says why. What it still buys is telling a
 * recount apart from a first load, and an instant switch back to a cached
 * filter set.
 */

import { keepPreviousData } from '@tanstack/react-query';

import { useFilteredQuery } from '@/hooks/use-filtered-query';

import { filtersQuestion, type Filters } from '@/lib/filters-schema';
import { fetchInboxKpis } from '@/services/inbox-api';
import type { InboxKpis } from '@/services/api-types';

export function useInboxKpis(filters: Filters) {
  return useFilteredQuery<InboxKpis>({
    queryKey: ['inbox', 'kpis', filtersQuestion(filters)],
    queryFn: async () => (await fetchInboxKpis(filters)).data,
    staleTime: 60_000,
    placeholderData: keepPreviousData,
  });
}
